$(document).on('click', '.hk-custom-tabs ul li', function () {
    var index = $(this).index() + 1;
    $('.hk-pdp-section1').removeClass('hk-active');
    $('.hk-custom-tab-section' + index).addClass('hk-active');


                 setTimeout(function () {
    var left = $('.hk-active .hk-custom-tabs ul li:nth-child('+index+')').position().left;
    $('.hk-custom-tabs').animate({
        scrollLeft: left
    }, 10);
                 }, 200);
});